<template>
  <div dir="rtl">
    <!-- <div style="margin-top: 200px;" v-if="pathLogo == m "></div>

        <div class="mlogo">
            <img class="wlogo" :src="pathLogo" />
        </div> -->

    <h3 style="font-size: 30px;" class="text-center">{{ alldata.fullName }}</h3>
    <h3 style="font-size: 20px;" class="text-center">
      {{ alldata.shortName }}
    </h3>
    <h3 class="text-center">
      كشف الحضور والإنصراف لشهر
      <b style="margin-right: 10px;"> {{ convertToUi(date) }}</b>
    </h3>

    <div style="margin: 60px 15px 0px 15px;" class="container body">
      <div class="c-1">الموظف</div>
      <div class="c-2">رقم الموظف</div>
      <div class="c-3">الوضع الحالي</div>
      <div class="c-4">مجموع الغياب</div>
      <div class="c-5">1</div>
      <div class="c-6">2</div>
      <div class="c-7">3</div>
      <div class="c-8">4</div>
      <div class="c-9">5</div>
      <div class="c-10">6</div>
      <div class="c-11">7</div>
      <div class="c-12">8</div>
      <div class="c-13">9</div>
      <div class="c-14">10</div>
      <div class="c-15">11</div>
      <div class="c-16">12</div>
      <div class="c-17">13</div>
      <div class="c-18">14</div>
      <div class="c-19">15</div>
      <div class="c-20">16</div>
      <div class="c-21">17</div>
      <div class="c-22">18</div>
      <div class="c-23">19</div>
      <div class="c-24">20</div>
      <div class="c-25">21</div>
      <div class="c-26">22</div>
      <div class="c-27">23</div>
      <div class="c-28">24</div>
      <div class="c-29">25</div>
      <div class="c-30">26</div>
      <div class="c-31">27</div>
      <div class="c-32">28</div>
      <div class="c-33">29</div>
      <div class="c-34">30</div>
      <div class="c-35">31</div>
    </div>

    <div
      style="margin: 0px 15px 0px 15px;"
      :style="i % 2 == 1 ? { background: '#f5f5f5' } : { background: '#fff' }"
      v-for="(item, i) in items"
      :key="i"
      class="container"
    >
      <div class="c-1">{{ item.employeeName }}</div>
      <div class="c-2">{{ item.jobNumber }}</div>
      <div class="c-3">
        {{
          item.currentSituation == 4
            ? "متفرغ"
            : item.currentSituation == 6
            ? "تدريب"
            : ""
        }}
      </div>
      <div class="c-4">{{ item.totalAbsents }}</div>

      <div
        v-for="(detail, dayIndex) in item.details"
        :key="dayIndex"
        :style="getDayStyle(detail)"
        :class="'c-' + (dayIndex + 5)"
      ></div>
    </div>

    <div style="direction: rtl;" class="md-layout md-size-100 text-center">
      <div class="md-layout-item md-size-15  mt-25">
        <h4 class="text-left">
          <span style="background-color: #7ecf81; " class=" col_color"></span> =
          حضور
        </h4>
      </div>

      <div class="md-layout-item md-size-15  mt-25">
        <h4 class="text-left">
          <span
            style="background-color: rgb(236, 187, 187); "
            class=" col_color"
          ></span>
          = غياب
        </h4>
      </div>

      <div class="md-layout-item md-size-15  mt-25">
        <h4 class="text-left">
          <span
            style="background-color: rgb(173, 200, 245); "
            class=" col_color"
          ></span>
          = إجازة
        </h4>
      </div>

      <div class="md-layout-item md-size-15  mt-25">
        <h4 class="text-left">
          <span style="background-color:  #d3d3d3; " class=" col_color"></span>
          = عطلة
        </h4>
      </div>

      <div class="md-layout-item md-size-15  mt-25">
        <h4 class="text-left">
          <span style="background-color:  #7ecf81; " class=" col_color"></span>
          = تأخير
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  mounted() {},
  props: ["items", "alldata", "date", "pathLogo"],
  data() {
    return {
      currentSort: "",
      m: env.mTop(),
      currentSortOrder: "asc",
      red: "#ecbbbb",
      blue: "#adc8f5",
      green: "#7ecf81",
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getMonth() + 1 + "-" + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    getDayStyle(detail) {
      if (!detail) return {};
      var state = detail.dayState;
      if (state == "ع") return { "background-color": "#d3d3d3" };
      if (state == "غ") return { "background-color": this.red };
      if (state == "ج") return { "background-color": this.blue };
      if (state == "ض" || state == "ت")
        return { "background-color": this.green };
      return {};
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/TimesheetView";

.col_color {
  margin-top: 60px;
  direction: rtl;
  color: black;
  background-color: rgb(236, 187, 187);
  padding: 0px 10px 0px 10px;
  margin-left: 10px;
}
</style>
